<template>
  <div>
    <h5 class="subtitulo">Projetos por Núcleo Solicitante</h5>
    <div class="chart-container">
      <div id="chart-projetos-nucleo-solicitante" class="chart"></div>
    </div>
  </div>
</template>
<script>
import { mapState } from 'vuex'
import * as am4core from '@amcharts/amcharts4/core'
import * as am4charts from '@amcharts/amcharts4/charts'
import am4themes_animated from '@amcharts/amcharts4/themes/animated'

export default {
  computed: {
    ...mapState('acompanhamentoDeProjetos', ['allProjetos']),
    nucleos() {
      const nucleosRepetidos = this.allProjetos.map((projeto) => ({
        setor: projeto.setor,
        descricaosetor: projeto.descricaosetor
      }))

      const idsNucleos = nucleosRepetidos.reduce(
        (acc, curr) => (acc.find((item) => item === curr.setor) ? acc : [...acc, curr.setor]),
        []
      )

      return idsNucleos.map((id) => {
        const nucleosMesmoId = nucleosRepetidos.filter((equipe) => equipe.setor === id)

        return {
          ...nucleosMesmoId[0],
          quantidade: nucleosMesmoId.length
        }
      })
    }
  },
  watch: {
    allProjetos(value) {
      if (value && value.length > 0) {
        this.renderGraphic()
      }
    }
  },
  methods: {
    formatarData(dataStr) {
      const [data, hora] = dataStr.split(' ')
      const [dia, mes, ano] = data.split('/')

      return `${ano}-${mes}-${dia} ${hora}`
    },
    renderGraphic() {
      am4core.useTheme(am4themes_animated)

      var chart = am4core.create('chart-projetos-nucleo-solicitante', am4charts.XYChart)
      chart.leftAxesContainer.minWidth = 150

      let cellSize = 30
      chart.events.on('datavalidated', function (ev) {
        let chart = ev.target
        let categoryAxis = chart.yAxes.getIndex(0)
        let adjustHeight = chart.data.length * cellSize - categoryAxis.pixelHeight
        let targetHeight = chart.pixelHeight + adjustHeight
        chart.svgContainer.htmlElement.style.height = targetHeight + 50 + 'px'
      })

      var colorSet = new am4core.ColorSet()
      colorSet.saturation = 0.4

      var categoryAxis = chart.yAxes.push(new am4charts.CategoryAxis())
      categoryAxis.renderer.grid.template.location = 0
      categoryAxis.dataFields.category = 'descricaosetor'
      categoryAxis.renderer.minGridDistance = 1
      categoryAxis.renderer.inversed = true
      categoryAxis.renderer.grid.template.disabled = true

      var valueAxis = chart.xAxes.push(new am4charts.ValueAxis())
      valueAxis.min = 0
      valueAxis.maxPrecision = 0

      var series = chart.series.push(new am4charts.ColumnSeries())
      series.dataFields.categoryY = 'descricaosetor'
      series.dataFields.valueX = 'quantidade'
      series.columns.template.tooltipText = '{descricaosetor}: {quantidade}'
      series.columns.template.propertyFields.fill = 'color'
      series.columns.template.propertyFields.stroke = 'color'
      series.columns.template.strokeOpacity = 1

      series.columns.template.adapter.add('fill', function (fill, target) {
        return chart.colors.getIndex(target.dataItem.index)
      })

      categoryAxis.sortBySeries = series
      chart.data = this.nucleos.map((item, index) => {
        const color =
          index === 0
            ? colorSet.getIndex(1)
            : colorSet.getIndex(
                index % 2 === 0
                  ? (index + 1) % colorSet.list.length
                  : colorSet.list.length - ((index + 1) % colorSet.list.length)
              )

        return {
          ...item,
          color
        }
      })

      chart.scrollbarX = new am4core.Scrollbar()
    }
  }
}
</script>